const TokenKey = 'access_token'

export function getToken() {
  const tokenData = localStorage.getItem(TokenKey)
  if (!tokenData) return null

  try {
    const { token, expires } = JSON.parse(tokenData)
    // 检查是否过期
    if (expires && Date.now() > expires) {
      removeToken()
      return null
    }
    return token
  } catch (e) {
    // 兼容旧版本字符串格式
    return tokenData
  }
}

export function setToken(token, expireTime) {
  let expires = null
  if (expireTime) {
    // expireTime 单位为秒，转换为毫秒时间戳
    expires = Date.now() + expireTime * 1000
  }
  const data = JSON.stringify({ token, expires })
  return localStorage.setItem(TokenKey, data)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}
